import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ThemeService} from '../themeService';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-popin',
  templateUrl: './cookie-popin.component.html',
  styleUrls: ['./cookie-popin.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class CookiePopinComponent implements OnInit, OnDestroy {

  @Input() policyUrl = '';
  @Input() cookiePolicyUrl = '';
  @Input() alternateDisplayForMarkets = false;
  @Output() action = new EventEmitter();
  @Output() actionOpen = new EventEmitter();
  logo = '';
  private logoSubscription: Subscription | undefined;

  constructor(private themeService: ThemeService) { }

  ngOnDestroy(): void {
    if (this.logoSubscription) {
      this.logoSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.logo = this.themeService.getLogo();
    this.logoSubscription = this.themeService.logoSubscription.subscribe( (logo: string) => {
      this.logo = logo;
    });
  }

  click = (action: true | false | string): void => {
    this.action.emit(action);
  };

}
